import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Box, Button, Grid, Typography, Accordion,
    AccordionSummary, AccordionDetails, CardContent, TextField, InputAdornment, Modal, Backdrop
} from '@mui/material';
import { getCarRppbProjects, getCompanyUserCarRppbs, getTableTotalRecordCount } from '../../../../actions/tigercat-burns/tigercat-base-actions';
import { getNoteLogs } from '../../../../actions/tigercat-burns/tigercat-operations-actions';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import BookmarkOutlinedIcon from '@mui/icons-material/BookmarkOutlined';
import moment from 'moment';
import Paginator from '../../../layout/Pagination';
import useTsPaginator from 'ts-paginator';
import SearchIcon from '@mui/icons-material/Search';

export const NoteLogs = () => {
    const dispatch = useDispatch();
    const [activeCarRppb, setActiveCarRppb] = useState(null);
    const [activeCarRppbProject, setActiveCarRppbProject] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
    const [selectedImage, setSelectedImage] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const carRppbs = useSelector(state => state.tigercatBurnsBaseReducer.carRppbs.data);
    const carRppbProjects = useSelector(state => state.tigercatBurnsBaseReducer.carRppbProjects.data);
    const noteLogs = useSelector(state => state.tigercatBurnsOperationsReducer.noteLogs);
    const { userData } = useSelector(state => state.auth);

    const userCompanyId = userData?.tigercatBurnsUser?.companyId;
    const tableRecordCount = useSelector(state => state.tigercatBurnsBaseReducer.totalRecordCount.count);

    const [hide, setHide] = useState(true);
    const [hideProjects, setHideProjects] = useState(true);

    const {
        totalRecordCount,
        rowsPerPage,
        currentPage,
        _determinePaginationMessage,
        _determinePaginationDisabledState,
        // _determinePaginationPages,
        _determineRowsPerPageOptions,
        _handleChangeTotalRecordCount,
        _handleChangeRowsPerPage,
        _handleChangePage,
    } = useTsPaginator(+tableRecordCount || 0, 10); // ✅ sensible default rowsPerPage = 10

    // Fetch initial data
    useEffect(() => {
        if (userCompanyId) {
            dispatch(getCompanyUserCarRppbs(userCompanyId));
        }
    }, [dispatch, userCompanyId]);

    // Fetch projects + total count when project changes
    useEffect(() => {
        if (activeCarRppbProject?.id) {
            dispatch(getTableTotalRecordCount('notes', activeCarRppbProject.id));
            _handleChangePage(1); // Reset to first page
        }
    }, [activeCarRppbProject?.id]);

    // Update debounced search query
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchQuery(searchQuery);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchQuery]);

    // Reset to first page on search change
    useEffect(() => {
        // console.log('debounced s', typeof (debouncedSearchQuery))
        _handleChangePage(1);
    }, [debouncedSearchQuery]);

    // Fetch note logs
    useEffect(() => {
        if (activeCarRppbProject) {
            dispatch(getNoteLogs(activeCarRppbProject.id, +rowsPerPage, +currentPage, debouncedSearchQuery))
            // _handleChangePage(1);
        }
    }, [dispatch, activeCarRppbProject, rowsPerPage, currentPage, debouncedSearchQuery]);

    // Update total record count from noteLogs response
    useEffect(() => {
        const total = noteLogs?.pagination?.total_records;
        if (total != null && total !== totalRecordCount) {
            _handleChangeTotalRecordCount(total);
            _handleChangePage(1);




        }
    }, [noteLogs]);

    const handleSetActiveCarRppb = (carRppb) => {
        setActiveCarRppb(carRppb);
        dispatch(getCarRppbProjects(carRppb.id));
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        _handleChangePage(1);


    };

    const handleImageClick = (image) => {
        setSelectedImage(image);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedImage(null);
    };
    return (
        <Grid>
            <Accordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    onClick={() => setHide(!hide)}
                >
                    <Typography>{hide ? "Hide" : "Expand"} CAR RPPBs</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid xs={12} display="flex" flexWrap="wrap" mb="1rem">
                        {carRppbs?.map((carRppb, index) => (
                            <Button
                                key={index}
                                sx={{ mr: 2 }}
                                variant={carRppb.id === activeCarRppb?.id ? 'contained' : 'outlined'}
                                onClick={() => handleSetActiveCarRppb(carRppb)}
                            >
                                {carRppb.reportingEntityName}
                            </Button>
                        ))}
                    </Grid>
                </AccordionDetails>
            </Accordion>

            {activeCarRppb && (
                <Accordion defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        onClick={() => setHideProjects(!hideProjects)}
                    >
                        <Typography>{hideProjects ? "Hide" : "Expand"} Projects</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container>
                            <Typography variant='h5' sx={{ mb: 3 }}>
                                CAR RPPB Projects
                            </Typography>
                            <Grid xs={12} display="flex" flexWrap="wrap" mb="1rem">
                                {carRppbProjects?.map((project, index) => (
                                    <Box
                                        key={index}
                                        className="biochar-project"
                                        sx={activeCarRppbProject?.id === project.id ? {
                                            background: 'linear-gradient(to bottom right, #535988, #313551)',
                                            color: '#FFF',
                                            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px'
                                        } : {}}
                                        onClick={() => setActiveCarRppbProject(project)}
                                    >
                                        <Typography sx={{ fontSize: '18px' }}>
                                            {activeCarRppbProject?.id === project.id ? <BookmarkOutlinedIcon sx={{ mb: '-7px' }} /> :
                                                <BookmarkBorderOutlinedIcon sx={{ mb: '-7px' }} />} {project.id}
                                        </Typography>
                                        <Typography sx={project.projectName ? { fontSize: '14px' } : { visibility: 'hidden' }} mt={3}>
                                            <strong>Project Name:</strong> {project.projectName}
                                        </Typography>
                                        <Typography sx={{ fontSize: '14px' }}>
                                            <strong>Date Created:</strong> {project.createdAt.split('T')[0]}
                                        </Typography>
                                    </Box>
                                ))}
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            )}

            {activeCarRppbProject && (
                <Box>
                    <Typography variant='h5' sx={{ my: 2.5 }}>Notes Log</Typography>
                    <TextField
                        label="Search Notes"
                        variant="outlined"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        sx={{ mb: 2 }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />

                    <Box sx={{
                        display: 'flex', flexWrap: 'wrap', rowGap: 4, columnGap: 4,
                        justifyContent: 'start', alignItems: 'start', mt: 0
                    }}>
                        {noteLogs?.data?.map((n, i) => (
                            <Box key={i} sx={{ display: 'flex', flexDirection: 'column' }}>
                                <CardContent sx={{
                                    maxWidth: 400,
                                    border: '1px solid lightgrey',
                                    borderRadius: '10px'
                                }}>
                                    <Typography variant="h6">
                                        Date: {moment(n.created_at).format('DD-MM-YYYY, h:mm:ss a')}
                                    </Typography>
                                    <Typography sx={{ color: 'text.secondary', mb: 1.5 }}>
                                        Submitted by: {n.user_name}
                                    </Typography>
                                    <Typography sx={{ display: 'block', mb: 2.5 }}>
                                        {n.note}
                                    </Typography>
                                    {n.note_media && (
                                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                                            <Box
                                                sx={{
                                                    position: 'relative',
                                                    width: 250,
                                                    height: 'auto',
                                                    display: 'inline-block',
                                                    '&:hover img': {
                                                        opacity: 0.7,
                                                        cursor: 'pointer',
                                                        transition: 'opacity 0.3s ease-in-out',
                                                    },
                                                    '&:hover .search-icon': {
                                                        opacity: 1,
                                                    },
                                                }}
                                            >
                                                <Box
                                                    onClick={() => handleImageClick(n.note_media)}
                                                    component="img"
                                                    src={n.note_media}
                                                    alt="note-image"
                                                    sx={{
                                                        width: '100%',
                                                        height: 'auto',
                                                        borderRadius: 2,
                                                        boxShadow: 3,
                                                        transition: 'opacity 0.3s ease-in-out',
                                                        display: 'block',
                                                    }}
                                                />

                                                <SearchIcon
                                                    className="search-icon"
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: '50%',
                                                        transform: 'translate(-50%, -50%)',
                                                        fontSize: 48,
                                                        color: '#ffffff',
                                                        opacity: 0,
                                                        transition: 'opacity 0.3s ease-in-out',
                                                        pointerEvents: 'none',
                                                    }}
                                                />
                                            </Box>
                                        </Box>
                                    )}
                                </CardContent>
                            </Box>
                        ))}
                    </Box>

                    <Paginator
                        key={`${debouncedSearchQuery}-${rowsPerPage}`}
                        debouncedSearchQuery={debouncedSearchQuery}
                        totalRecordCount={totalRecordCount}
                        rowsPerPage={rowsPerPage}
                        currentPage={currentPage}
                        handleChangePage={_handleChangePage}
                        handleChangeRowsPerPage={_handleChangeRowsPerPage}
                        determinePaginationMessage={_determinePaginationMessage}
                        determinePaginationDisabledState={_determinePaginationDisabledState}
                        determineRowsPerPageOptions={_determineRowsPerPageOptions}
                    />

                    <Modal

                        open={isModalOpen}
                        onClose={handleCloseModal}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                            sx: {
                                backdropFilter: 'blur(6px)',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            },
                        }}
                    >
                        <Box
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                bgcolor: 'background.paper',
                                p: 2,
                                borderRadius: 2,
                                boxShadow: 24,
                                outline: 'none',
                                maxWidth: '90vw',
                                maxHeight: '90vh',
                                overflow: 'hidden', // ✅ Prevent image from overflowing container
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Box
                                component="img"
                                src={selectedImage}
                                alt="Expanded note image"
                                sx={{
                                    maxWidth: '90vw',     // ✅ Image won't exceed viewport
                                    maxHeight: '80vh',
                                    objectFit: 'contain',
                                    borderRadius: 2,
                                    display: 'block',
                                }}
                            />
                        </Box>
                    </Modal>
                </Box>
            )}
        </Grid>
    );
};